var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000001",
  d: "M0 0h213.3v480H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd90c",
  d: "M213.3 0h213.4v480H213.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f31830",
  d: "M426.7 0H640v480H426.7z"
}))));
SvgBe.displayName = "SvgBe";
export { SvgBe as ReactComponent };
export default SvgBe;